<div class="icon-container">
  <div class="protrude"></div>
  <div class="icon">
    <i class="fa fa-fw fa-{{icon}}"></i>
  </div>
</div>